import { useField } from "formik";
import isEmpty from "lodash-es/isEmpty";
import {
  EfsMelcoEfsModelsMappingFileAttribute,
  EfsMelcoEfsModelsSchemaListItem,
  VerticalForm,
  DebugForm,
} from "melco-shared-logic";
import { Alert, AlertWrapper } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useFilenameRulesValidation } from "../../hooks/inputFormats/useFilenameRulesValidation";
import { useAdvancedOptions } from "../../hooks/settings/useAdvancedOptions";
import { AddOrSaveButton } from "./AddOrSaveButton";
import { DynamicFilenameRule } from "./DynamicFilenameRule";
import { FilenameRuleFormMode } from "./FilenameRuleDrawer";
import { ScopedFilenameRule } from "./ScopedFilenameRule";
import { SelectFilenameRuleType } from "./SelectFilenameRuleType";
import { StaticFilenameRule } from "./StaticFilenameRule";

type DisplayFilenameRuleFormProps = {
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
  filenameRules: EfsMelcoEfsModelsMappingFileAttribute[];
  formMode: FilenameRuleFormMode;
  isAddingNewRule: boolean;
};

export const DisplayFilenameRuleForm: React.FC<
  DisplayFilenameRuleFormProps
> = ({ dataAssignments, formMode, isAddingNewRule, filenameRules }) => {
  const { t } = useTranslation();

  const [{ value: type }] = useField("type");

  const isAdvancedOptionsEnabled = useAdvancedOptions();

  const violatedConstraints = useFilenameRulesValidation(
    formMode,
    type,
    filenameRules
  );

  const isAddingAllowed = violatedConstraints.length === 0;

  return (
    <VerticalForm>
      {!isEmpty(violatedConstraints) && (
        <AlertWrapper>
          <Alert
            message={t("inputFormats.actions.filenameRules.constraints.title")}
            type="error"
            withBackground
            description={violatedConstraints.map((violatedConstraint) => (
              <div key={violatedConstraint}>
                {t(
                  `inputFormats.actions.filenameRules.constraints.${violatedConstraint}`
                )}
              </div>
            ))}
          />
        </AlertWrapper>
      )}

      <SelectFilenameRuleType
        isAdvancedOptionsEnabled={isAdvancedOptionsEnabled}
        isDisabled={!isAddingNewRule}
      />

      <DynamicFilenameRule
        isAdvancedOptionsEnabled={isAdvancedOptionsEnabled}
        dataAssignments={dataAssignments}
      />

      <StaticFilenameRule />

      <ScopedFilenameRule
        dataAssignments={dataAssignments}
        scopeType="Scoped"
      />

      <ScopedFilenameRule
        dataAssignments={dataAssignments}
        scopeType="ScopedPrefix"
      />

      <ScopedFilenameRule
        dataAssignments={dataAssignments}
        scopeType="ScopedSuffix"
      />

      <AddOrSaveButton formMode={formMode} disabled={!isAddingAllowed} />

      {false && <DebugForm />}
    </VerticalForm>
  );
};
